/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![EyeSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACIUlEQVR4nNWVv2sUURDH1x8gqUwRay3EaBMs0ljIFYmw6L7vzAbfzWyatIFURtPYXFqxEa0EWxWi/4B/gEmjYAqxURG0CkggaCwiKvN2g7uXvb0fmMKBK+7ee5+Z953vm4ui/y2SJJsA6Quw3DkcOMsmWH9bkr4HWq3WcaLMOZZnIPkEkh9g/Q6SD471MdCerYWzbNr3RrhLNQ7QcKDXR5ZHgR9xpPf2IY71LaA3nNMp7/1J7/0Y4CeJ5PJIcLA+CmDSXQN3Op2jvTYPLwvJ7WLzt4Rkpmlv7P2pOjiRnKmvhrNLjvQnWH8BivIa4Cet0cxyoalysKyAdY9o/mIFbjKA9E1x4H55jVnOOZZtR7LaTxbzfm5RWa9IC+j1XHf5bE2sVM/yfBC4hZkApFu2TiTyF0KyXrhmsVs67iNLdyDVpeKhbZQS6Eb4MdWl2v4k9fD95NUb62Jh75elrG0tsm7ZNQeBO5JVkK51STRmMoe90LS7yfktSkOqCe5Ivzrnz1aqJ32QVy+vDrwfs1ZuU1npJwtI1w7AoQgWZ90DdLpO6ujq3PzpJnivSDhrOdadYgLcjEZ5oXXhvT8WHlc+Zc2FD23cRMPCE5KZZC47b00kWhg3OROSWyB5V4BNmrsjwcGy3Dyy9aNL9UpPcBM8JEB7FiRPHOl7G4JhyhqU9ClSvWYyNcKDjqSvBx650ZARx/EJsH6xJP8cXk5i/7+HAf8DrnuTYh6Ij7cAAAAASUVORK5CYII=)
 */
export const EyeSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M1.3 21.3a1 1 0 1 0 1.4 1.4l20-20a1 1 0 0 0-1.4-1.4l-20 20ZM3.16 16.05c.18.24.53.26.74.05l.72-.72c.18-.18.2-.45.05-.66a15.7 15.7 0 0 1-1.43-2.52.48.48 0 0 1 0-.4c.4-.9 1.18-2.37 2.37-3.72C7.13 6.38 9.2 5 12 5c.82 0 1.58.12 2.28.33.18.05.38 0 .52-.13l.8-.8c.25-.25.18-.67-.15-.79A9.79 9.79 0 0 0 12 3C4.89 3 1.73 10.11 1.11 11.7a.83.83 0 0 0 0 .6c.25.64.9 2.15 2.05 3.75Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8.18 10.81c-.13.43.36.65.67.34l2.3-2.3c.31-.31.09-.8-.34-.67a4 4 0 0 0-2.63 2.63ZM12.85 15.15c-.31.31-.09.8.34.67a4.01 4.01 0 0 0 2.63-2.63c.13-.43-.36-.65-.67-.34l-2.3 2.3Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M9.72 18.67a.52.52 0 0 0-.52.13l-.8.8c-.25.25-.18.67.15.79 1.03.38 2.18.61 3.45.61 7.11 0 10.27-7.11 10.89-8.7a.83.83 0 0 0 0-.6c-.25-.64-.9-2.15-2.05-3.75a.49.49 0 0 0-.74-.05l-.72.72a.51.51 0 0 0-.05.66 15.7 15.7 0 0 1 1.43 2.52c.06.13.06.27 0 .4-.4.9-1.18 2.37-2.37 3.72C16.87 17.62 14.8 19 12 19c-.82 0-1.58-.12-2.28-.33Z"
        className={colorClass}
      />
    </svg>
  );
};
